import { StyleSheet , View } from "react-native"
import React from "react"

const EmptyBox=({ style , backgroundColor  , width , height })=>{
    return (
        <View style={[styles.container , { backgroundColor , width , height } , style]}/>
    )
}

export default EmptyBox

const styles = StyleSheet.create({
    container : {
       width : '100%' , 
    }
})